// Web vitals functionality removed to avoid API compatibility issues
const reportWebVitals = () => {
  // No-op function - web vitals reporting disabled
};

export default reportWebVitals;
